module.exports = __webpack_public_path__ + "static/img/7.8c7edf2a.jpg";